module.exports = __webpack_public_path__ + "img/load-rawk-1.97e594ca.gif";